import React from "react";

function CrownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="36"
      fill="none"
      viewBox="0 0 32 36"
    >
      <rect
        width="30.24"
        height="33.48"
        x="0.54"
        y="1.08"
        stroke="#E6E6E6"
        strokeWidth="1.08"
        rx="15.12"
      ></rect>
      <path
        stroke="#00D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.62"
        d="M15.66 11.61l4.14 6.21 5.176-4.14-2.07 10.35H8.416l-2.07-10.35 5.175 4.14 4.14-6.21z"
      ></path>
    </svg>
  );
}

export default CrownIcon;
